"use client";

import React from "react";
import { motion } from "framer-motion";
import { Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="rounded-lg border border-green-200 bg-green-50 p-6">
        <p className="text-green-800">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-4">
          Send Another Message
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <FormField control={control} name="name" rules={{
      required: "Name is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Name</FormLabel>
            <FormControl>
              <Input placeholder="Your Name" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />
      <FormField control={control} name="email" rules={{
      required: "Email is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Email</FormLabel>
            <FormControl>
              <Input type="email" placeholder="you@example.com" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />
      <FormField control={control} name="phone" rules={{
      required: "Phone is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Phone</FormLabel>
            <FormControl>
              <Input type="tel" placeholder="Your Phone Number" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />
      <FormField control={control} name="message" rules={{
      required: "Message is required"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Message</FormLabel>
            <FormControl>
              <Textarea placeholder="How can we help you?" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />
      {submitError && <div className="rounded-lg border border-red-200 bg-red-50 p-4">
          <p className="text-red-800">{submitError}</p>
        </div>}
      <Button type="submit" disabled={isSubmitting} className="w-full">
        {isSubmitting ? <>
            <Loader className="mr-2 size-4 animate-spin" />
            Sending...
          </> : "Send Message"}
      </Button>
    </Form>;
}
export default function ContactInquiryForm() {
  return <section id="contactinquiryform" className="bg-background py-24">
      <div className="mx-auto max-w-4xl px-6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="mb-12 text-center">
          <h2 className="mb-4 font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            {"Get in Touch with Coastline"}
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            {"Have a question about our air conditioning services or need a quote? Fill out the form below and our team will get back to you promptly."}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        delay: 0.2,
        ease: "easeOut"
      }} className="rounded-xl border border-border bg-card p-8 shadow-md md:p-10">
          <FormProvider formId="contact_inquiry_form" sectionName="contact-inquiry" defaultValues={{
          name: "",
          email: "",
          phone: "",
          message: ""
        }}>
            <ContactForm />
          </FormProvider>
        </motion.div>
      </div>
    </section>;
}